import { createStructuredSelector } from 'reselect';
import {
    TASK_VEHICLE_AUDIT_LIST,
    TASK_VEHICLE_AUDIT_LIST_SUCCESS,
    TASK_VEHICLE_AUDIT_LIST_ERROR,
    TASK_VEHICLE_AUDIT_MODAL_SET
} from '../../actions';

export const TaskVehicleAuditList = (id_task) => ({
    type: TASK_VEHICLE_AUDIT_LIST,
    payload: { id_task }
});

export const TaskVehicleAuditListSuccess = (data) => ({
    type: TASK_VEHICLE_AUDIT_LIST_SUCCESS,
    payload: data
});

export const TaskVehicleAuditListError = (error) => ({
    type: TASK_VEHICLE_AUDIT_LIST_ERROR,
    payload: error
});

export const TaskVehicleAuditModalSet = (modal) => ({
    type: TASK_VEHICLE_AUDIT_MODAL_SET,
    payload: modal
});

const task_vehicle_audit = (state) => state['task_vehicle_audit'];
export const TaskVehicleAuditSelector = createStructuredSelector({ task_vehicle_audit });
